module.exports = __webpack_public_path__ + "static/media/12UNCTAD2.69c91590.jpg";